import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPRODUCTADDMODAL_LEGACY_FIELD_ORDER = [
  { type: 'groupedFields', handle: 'theme_colors', fields: ["backgroundColor","secondaryColor","textColor","buttonBackgroundColor","buttonTextColor","unavailableButtonBackground","unavailableButtonText","cardColor","compositionBackgroundColor"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskProductAddModalDescriptor: _generatedKioskProductAddModalDescriptor,
  kioskProductAddModalModalDefinition,
  kioskProductAddModalDashboardLayout,
  kioskProductAddModalConfig,
  kioskProductAddModalResolveConfig,
  kioskProductAddModalProperties,
} = doodModalConfig(
  {
    name: "Kiosk - Product add modal",
    handle: "kiosk-product-add-modal",
    internal_name: "KioskProductAddModal",
    componentType: 'KioskProductAddModalComponent',
    category: 'modal',
    description: "Kiosk - Product add modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "kiosk-product-add-modal",
    sharedFields: {}
  },

  () => ({
    theme_colors: {
      backgroundColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Fond principal"
        }
      }),
      secondaryColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Couleur secondaire"
        }
      }),
      textColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Texte"
        }
      }),
      buttonBackgroundColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Fond des boutons"
        }
      }),
      buttonTextColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Texte des boutons"
        }
      }),
      unavailableButtonBackground: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Fond bouton indisponible"
        }
      }),
      unavailableButtonText: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Texte bouton indisponible"
        }
      }),
      cardColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Carte produit"
        }
      }),
      compositionBackgroundColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Fond composition / options"
        }
      })
    }
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["theme_colors.backgroundColor", "theme_colors.secondaryColor", "theme_colors.textColor", "theme_colors.buttonBackgroundColor", "theme_colors.buttonTextColor", "theme_colors.unavailableButtonBackground", "theme_colors.unavailableButtonText", "theme_colors.cardColor", "theme_colors.compositionBackgroundColor"],
          },
        ],
      },
    ],
  })
);

export function kioskProductAddModalDescriptor(): IBlockDescriptor;
export function kioskProductAddModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskProductAddModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskProductAddModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskProductAddModalDescriptor, kioskProductAddModalProperties, fieldOrder);
}

export {
  kioskProductAddModalModalDefinition,
  kioskProductAddModalDashboardLayout,
  kioskProductAddModalProperties,
  kioskProductAddModalConfig,
  kioskProductAddModalResolveConfig,
};

export type KioskProductAddModalConfig = typeof kioskProductAddModalConfig;
